import { useCallback, useEffect, useState } from "react";
import { chatService } from "../../services/resources/chatService";
import { openNotification } from "../Notification";

export function useChatContatos(autorizado, vista) {
  const [contatos, setContatos] = useState([]);
  const [instituicoes, setInstituicoes] = useState([]);
  const [buscaContato, setBuscaContato] = useState("");
  const [instituicaoContato, setInstituicaoContato] = useState();
  const [carregandoContatos, setCarregandoContatos] = useState(false);

  const resetar = useCallback(() => {
    setBuscaContato("");
    setInstituicaoContato(undefined);
  }, []);

  useEffect(() => {
    if (!autorizado || vista !== "nova") return undefined;
    chatService
      .listarInstituicoes()
      .then(({ data }) => setInstituicoes(Array.isArray(data) ? data : []))
      .catch((error) => {
        openNotification(
          "error",
          <strong>Não foi possível carregar as instituições</strong>,
          error?.response?.data?.userMessage || error?.response?.data?.detail
        );
      });
    return undefined;
  }, [autorizado, vista]);

  useEffect(() => {
    if (!autorizado || vista !== "nova") return undefined;
    setCarregandoContatos(true);
    const timer = setTimeout(async () => {
      try {
        const { data } = await chatService.listarContatos(
          buscaContato,
          instituicaoContato
        );
        setContatos(Array.isArray(data) ? data : []);
      } catch (error) {
        openNotification(
          "error",
          <strong>Não foi possível carregar os contatos</strong>,
          error?.response?.data?.userMessage || error?.response?.data?.detail
        );
      } finally {
        setCarregandoContatos(false);
      }
    }, 250);
    return () => clearTimeout(timer);
  }, [autorizado, vista, buscaContato, instituicaoContato]);

  return {
    contatos,
    instituicoes,
    buscaContato,
    setBuscaContato,
    instituicaoContato,
    setInstituicaoContato,
    carregandoContatos,
    resetar,
  };
}
